// extracted by mini-css-extract-plugin
export default {"SearchPanel":"po_a bhr_ea bhr_ke bhr_ju bhr_a bhr_j bhr_so bhr_sp","SearchPanel__icon":"po_b bhr_vo bhr_hi bhr_su bhr_va","SearchPanel__input":"po_c bhr_jb bhr_eg bhr_z"};